import { Component } from 'js-component-framework';

/**
 * Component for search flyout
 */
export default class TOCMove extends Component {
  static getViewportWidth() {
    const viewportWidth = window.innerWidth
      || document.documentElement.clientWidth;
    return viewportWidth;
  }

  /**
   * Start the component
   */
  constructor(config) {
    super(config);
    this.init();
  }

  handleTOCMove() {
    const {
      element,
    } = this;
    // Get height of the subnav.
    const height = element.offsetHeight;

    if (0 < height) {
      const toc = document.querySelector('.block--table-of-contents');
      document.querySelector('.entry-sidebar').append(toc);
    }
  }

  init() {
    const {
      controller,
      target,
    } = this.children;

    if (! controller || ! target) {
      return;
    }

    this.handleTOCMove();
  }
}
